<template>
  <el-dialog
    class="mobile-dialog"
    :width="width"
    :title="description.title"
    :visible.sync="visible"
    :show-close="false"
    :modal="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="content">
      <p v-html="description.content">
        请在电脑浏览器打开网址体验更多功能：<a
          id="pcLink"
          href="https://www.qylsbl.com/#/index"
          >https://www.qylsbl.com/#/index</a
        >，您也可以留下联系方式，方便我们业务人员跟您沟通：
      </p>
      <!-- form -->
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <el-form-item label="" prop="refer">
          <el-input
            v-model="form.refer"
            placeholder="称呼"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="info">
          <el-input
            v-model="form.info"
            placeholder="手机或邮箱"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="contact"
        >提交</el-button
      >
      <!--<el-button data-clipboard-text="https://www.qylsbl.com/#/index"-->
      <!--&gt;复制链接</el-button-->
      <!--&gt;-->
      <el-button type="default" @click="visible = false">知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Clipboard from "clipboard";
import { mapGetters } from "vuex";
import config from "@/config";
import { mobilePattern, emailPattern } from "@/libs/formValidate";

export default {
  props: {
    // width: {
    //   default: "90%"
    // },
    title: {
      default: "移动端暂不支持"
    },
    content: {
      default: `请在电脑浏览器打开网址体验更多功能：<a id="pcLink" href="https://www.qylsbl.com/#/index">https://www.qylsbl.com/#/index</a>`
    }
  },
  data() {
    return {
      visible: false,
      description: {
        title: "",
        content: ""
      },
      form: {
        refer: "",
        info: ""
      },
      rules: {
        info: {
          validator: this.validateContact
        }
      },
      loading: false
    };
  },

  computed: {
    ...mapGetters(["isMobile"]),

    width() {
      return this.isMobile ? "90%" : "50%";
    }
  },

  methods: {
    show(type = "info") {
      this.visible = true;
      this.initDescription(type);
    },

    // 初始化文案
    initDescription(type) {
      let title = "";
      let content = "";

      // 联系信息
      let contactContent = () => {
        const tels = config.telephones
          .map(t => `<span style="padding: 2px 0; color: #449786;">${t}</span>`)
          .join("；");
        return `您可以主动联系我们：${tels}或者可以留下联系方式，方便我们业务人员跟您进一步沟通：`;
      };

      switch (type) {
        // 移动端info
        case "info":
          title = "移动端暂不支持";
          content = `请在电脑浏览器打开网址体验更多功能：<a id="pcLink" href="https://www.qylsbl.com/#/index">https://www.qylsbl.com/#/index</a>，您也可以留下联系方式，方便我们业务人员跟您沟通：`;
          break;
        // 移动端error
        case "error":
          title = "该企业暂无授信";
          content = contactContent();
          break;
        // PC端info
        case "infoPC":
          title = "请先登录再进行申报";
          content = contactContent();
          break;
      }

      this.description.title = title;
      this.description.content = content;
    },

    validateContact(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      const mobileReg = mobilePattern();
      const emailReg = emailPattern();

      mobileReg.test(value) || emailReg.test(value)
        ? callback()
        : callback(new Error("请输入正确的格式"));
    },

    copy() {},

    contact() {
      if (!this.form.info) {
        this.$message.warning("请输入联系方式");
        return;
      }

      this.loading = true;
      const param = { ...this.form };

      this.$request
        .inquiry_contact(param)
        .then(res => {
          const { code, msg } = res;

          if (code !== 0) {
            this.$message.error(msg);
            return;
          }

          this.$message.success("提交成功");
          this.visible = false;
          this.clear();
        })
        .finally(() => (this.loading = false));
    },

    clear() {
      this.form.info = "";
      this.form.resetFields();
    }
  }
};
</script>

<style lang="scss">
.mobile-dialog {
  a {
    color: $high;
  }

  .form {
    margin-top: 20px;
  }
}
</style>
